<div class="main-wrapper">
  <div class="container">
      <div class="heading text-center">
        {{section?.header}}
      </div>
      <div class="divider"></div>
      <div class="row">
        <div class="col-md-6 col-lg-6 col-12" *ngFor="let item of section?.data_images">
          <div class="{{item?.icon_class}}"></div>
          <div class="text-heading text-center">{{item?.text}}</div>
          <div class="text-desc">{{item?.text_desc}}</div>
        </div>
      </div>
    </div>
</div>

